export const CONTACT_EMAIL = "a.kelleci@almoragroup.com";
export const CONTACT_ADDRESS = "#74 A. Ioseliani Str., Tbilisi, Georgia";
